// Angular
import { AfterViewInit, Component, HostBinding, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
// RxJS
import { filter } from 'rxjs/operators';
// Translate
import { TranslationService } from '../../../../../core/_base/layout';
import { CommonService } from '../../../../../Service/common/common-service.service';
import {environment} from '../../../../../../environments/environment';

interface LanguageFlag {
	langid: string;
	lang: string;
	name: string;
	flag: string;
	active?: boolean;
}

@Component({
	selector: 'kt-language-selector',
	templateUrl: './language-selector.component.html',
})
export class LanguageSelectorComponent implements OnInit, AfterViewInit {
	// Public properties
	@HostBinding('class') classes = '';
	@Input() iconType: '' | 'brand';

	language: LanguageFlag;
	languages: LanguageFlag[];

	/**
	 * Component constructor
	 *
	 * @param translationService: TranslationService
	 * @param router: Router
	 */
	constructor(private translationService: TranslationService, private router: Router, private objCommonService:CommonService, private changeDetectorRef: ChangeDetectorRef) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
		this.languages=[];
		this.GetApplicationLanguages();
	}

	ngAfterViewInit(): void {

	}


	/**
	 * Set language
	 *
	 * @param lang: any
	 */

	setLanguageOnLoad(lang) {

		this.languages.forEach((language: LanguageFlag) => {
			if (language.lang === lang) {
				language.active = true;
				this.language = language;
			} else {
				language.active = false;
			}
		});
		this.translationService.setLanguage(lang);
	}

	setLanguage(lang, langid) {
		this.languages.forEach((language: LanguageFlag) => {
			if (language.lang === lang) {
				language.active = true;
				this.language = language;
			} else {
				language.active = false;
			}
		}); 
		this.translationService.setLanguage(lang);
 
		this.objCommonService.ChangeLanguage(langid).subscribe(data=>{
			
			localStorage.clear();
			localStorage.setItem('currentUser', JSON.stringify(data));
			localStorage.setItem('LanguageId', JSON.stringify(data.LanguageId));
			localStorage.setItem('PortalUser', JSON.stringify(data.PortalUser));
			// var str = localStorage.getItem('ModuleId');
			// alert(str);

			//window.location.href='/#/dashboard';
			//window.location.reload(); 
			//window.location.href='/dashboard';
			//this.router.navigate(['/dashboard']);
			this.router.navigate(['widget/widget-dashboard/3']);
			window.location.reload(); 
		})
	}

	/**
	 * Set selected language
	 */
	setSelectedLanguage(): any {
		//this.setLanguage(this.translationService.getSelectedLanguage());
	}

	GetApplicationLanguages()
	{
	  this.objCommonService.GetApplicationLanguages().subscribe(LanguageList=>{
		if(LanguageList == null)
		{
			document.getElementById('MainDiv').style.display = 'none';
		}
		else
	  	{
			this.languages = LanguageList;
			for(var i=0; i<= LanguageList.length; i++)
			{
				if(this.languages[i] != null)
				{
					this.languages[i].flag = environment.baseUrl.replace("api/", "") + this.languages[i].flag;	

					if(LanguageList[i].active == true)
					{
						this.setLanguageOnLoad(LanguageList[i].lang);
					}
				}
			}
		}
	    this.changeDetectorRef.detectChanges();
	  })
	}
}
  